"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.loadScripts = exports.loadScriptsStandAlone = void 0;
// import from npm
var loadjs_1 = __importDefault(require("loadjs"));
var get_script_map_1 = __importDefault(require("./get-script-map"));
/**
 * @deprecated use loadScripts instead
 */
var loadScriptsStandAlone = function (secure) {
    if (secure === void 0) { secure = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, (0, exports.loadScripts)(secure)];
        });
    });
};
exports.loadScriptsStandAlone = loadScriptsStandAlone;
var loadJsDefaultOptions = {
    numRetries: 3,
    returnPromise: true
};
var loadScripts = function (secure, loadLegacyModules) {
    if (secure === void 0) { secure = true; }
    if (loadLegacyModules === void 0) { loadLegacyModules = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a, coreScript, coreLegacyScript, serviceLegacyScript, scripts;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = (0, get_script_map_1["default"])(secure), coreScript = _a.coreScript, coreLegacyScript = _a.coreLegacyScript, serviceLegacyScript = _a.serviceLegacyScript, scripts = __rest(_a, ["coreScript", "coreLegacyScript", "serviceLegacyScript"]);
                    if (!!loadjs_1["default"].isDefined("mapsjs-core")) return [3 /*break*/, 2];
                    // Make sure this is loaded before the others
                    return [4 /*yield*/, (0, loadjs_1["default"])(coreScript, "mapsjs-core", loadJsDefaultOptions)];
                case 1:
                    // Make sure this is loaded before the others
                    _b.sent();
                    _b.label = 2;
                case 2:
                    if (!!loadjs_1["default"].isDefined("mapsjs")) return [3 /*break*/, 4];
                    return [4 /*yield*/, (0, loadjs_1["default"])(Object.values(scripts), "mapsjs", loadJsDefaultOptions)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    if (!(loadLegacyModules && !loadjs_1["default"].isDefined("mapsjs-legacy"))) return [3 /*break*/, 6];
                    return [4 /*yield*/, (0, loadjs_1["default"])([coreLegacyScript, serviceLegacyScript], "mapsjs-legacy", loadJsDefaultOptions)];
                case 5:
                    _b.sent();
                    _b.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
};
exports.loadScripts = loadScripts;
